module.exports = __webpack_public_path__ + "images/5ee613d.png";